module.exports = __webpack_public_path__ + "static/img/faq-1.b102bb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/faq-1.png
// module id = spxn
// module chunks = 4